const faqs = [
  {
    question: 'O que é CSSBuy Spreadsheet?',
    answer:
      'CSSBuy Spreadsheet é uma ferramenta de organização usada para comparar e gerenciar compras internacionais da China. Ele permite registrar produtos, preços, lojas e opções de envio em uma única planilha, facilitando a tomada de decisão antes de finalizar qualquer pedido.',
    user: 'Maria S.',
    role: 'Compradora desde 2023',
  },
  {
    question: 'CSSBuy Spreadsheet é seguro?',
    answer:
      'Sim, o CSSBuy é uma plataforma estabelecida com boa reputação. No entanto, como em qualquer compra internacional, é importante declarar valores corretamente, usar frete rastreado e verificar a reputação das lojas antes de comprar.',
    user: 'João P.',
    role: 'Usuário verificado',
  },
  {
    question: 'Como funciona o frete da China para o Brasil?',
    answer:
      'O frete varia conforme o peso, dimensões e método de envio escolhido. As opções incluem EMS, China Post, DHL e linhas econômicas. Recomendamos usar frete rastreado e declarar valores realistas para evitar problemas alfandegários.',
    user: 'Ana C.',
    role: 'Especialista em importação',
  },
  {
    question: 'Posso comprar de várias lojas em um só pedido?',
    answer:
      'Sim! Uma das principais vantagens do CSSBuy Spreadsheet é a capacidade de consolidar produtos de diferentes lojas em um único envio, o que reduz significativamente os custos de frete e simplifica o processo de importação.',
    user: 'Pedro L.',
    role: 'Comprador frequente',
  },
  {
    question: 'Quanto tempo leva para chegar?',
    answer:
      'O prazo de entrega varia de 15 a 45 dias dependendo do método de frete escolhido. Linhas expressas como DHL podem entregar em 7-15 dias, enquanto linhas econômicas podem levar de 30 a 60 dias.',
    user: 'Lucas M.',
    role: 'Usuário desde 2022',
  },
];

export default function FaqSection() {
  return (
    <section className="w-full py-14 md:py-20 px-6 md:px-10 bg-background-100" id="faq">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-question-answer-line text-accent-500 text-xl"></i>
            </div>
            <span className="text-xs font-semibold text-foreground-500 tracking-wide">
              FAQ & DEPOIMENTOS
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
            Perguntas Frequentes
          </h2>
          <p className="mt-3 text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            Tire suas dúvidas sobre CSSBuy Spreadsheet e veja o que outros compradores
            estão dizendo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {faqs.slice(0, 3).map((faq, idx) => (
            <div
              key={idx}
              className={`rounded-2xl p-6 ${
                idx === 2
                  ? 'relative overflow-hidden bg-cover bg-center'
                  : 'bg-background-200/60'
              }`}
            >
              {idx === 2 && (
                <>
                  <img
                    src="https://readdy.ai/api/search-image?query=Warm%20toned%20packaging%20station%20with%20kraft%20paper%20wrapping%20supplies%20and%20fabric%20samples%20on%20a%20wooden%20table%2C%20soft%20diffused%20window%20light%2C%20creative%20workshop%20editorial%20photography%2C%20earthy%20terracotta%20and%20cream%20palette%2C%20handcrafted%20shopping%20aesthetic&width=600&height=800&seq=faq-card-bg-v5&orientation=portrait"
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary-800/80 via-primary-900/30 to-transparent"></div>
                </>
              )}

              <div className={idx === 2 ? 'relative z-10' : ''}>
                {idx !== 2 && (
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-background-300 flex items-center justify-center overflow-hidden">
                      <i className="ri-user-line text-foreground-500"></i>
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-foreground-900">
                        {faq.user}
                      </div>
                      <div className="text-xs text-foreground-500">{faq.role}</div>
                    </div>
                  </div>
                )}
                <div className={`text-3xl mb-3 ${idx === 2 ? 'text-accent-300' : 'text-accent-400'}`}>
                  <i className="ri-double-quotes-l"></i>
                </div>
                <h4
                  className={`font-semibold mb-3 text-sm md:text-base ${
                    idx === 2 ? 'text-background-50' : 'text-foreground-900'
                  }`}
                >
                  {faq.question}
                </h4>
                <p
                  className={`text-sm leading-relaxed ${
                    idx === 2 ? 'text-background-50/80' : 'text-foreground-600'
                  }`}
                >
                  {faq.answer}
                </p>
                {idx === 2 && (
                  <div className="flex items-center gap-3 mt-4 pt-4 border-t border-background-50/20">
                    <div className="w-8 h-8 rounded-full bg-background-50/30 flex items-center justify-center">
                      <i className="ri-user-line text-background-50"></i>
                    </div>
                    <div>
                      <div className="text-xs font-semibold text-background-50">{faq.user}</div>
                      <div className="text-xs text-background-50/70">{faq.role}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-5">
          <div className="md:col-span-2 relative rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Organized%20product%20catalog%20with%20fabric%20swatches%20and%20color%20cards%20arranged%20on%20a%20light%20oak%20table%2C%20soft%20natural%20morning%20light%2C%20creative%20studio%20editorial%20photography%2C%20warm%20neutral%20palette%2C%20professional%20product%20curation%20aesthetic&width=900&height=500&seq=faq-wide-bg-v5&orientation=landscape"
              alt=""
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-800/85 via-primary-900/30 to-transparent"></div>
            <div className="relative z-10 p-6 md:p-8">
              <span className="inline-block px-2 py-0.5 bg-accent-500/80 text-background-50 rounded text-[10px] font-semibold mb-3">
                DESTAQUE
              </span>
              <h4 className="text-xl md:text-2xl font-heading font-semibold text-background-50 mb-3">
                {faqs[3].question}
              </h4>
              <p className="text-background-50/85 text-sm leading-relaxed max-w-lg">
                {faqs[3].answer}
              </p>
            </div>
          </div>

          <div className="bg-background-200/60 rounded-2xl p-5 flex flex-col justify-between">
            <div>
              <div className="text-2xl text-accent-400 mb-3">
                <i className="ri-double-quotes-l"></i>
              </div>
              <h4 className="font-semibold text-sm text-foreground-900 mb-2">
                {faqs[4].question}
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {faqs[4].answer}
              </p>
            </div>
            <div className="flex items-center gap-3 mt-4 pt-4 border-t border-background-300/60">
              <div className="w-8 h-8 rounded-full bg-background-300 flex items-center justify-center">
                <i className="ri-user-line text-foreground-500"></i>
              </div>
              <div>
                <div className="text-xs font-semibold text-foreground-900">{faqs[4].user}</div>
                <div className="text-xs text-foreground-500">{faqs[4].role}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}